module.exports = __webpack_public_path__ + "f2fad24fffc6f3f4efb0b06f6b287150.png";